import Tile, { TileType } from './tile'


export default Tile
export { TileType }
